
/**
 * Represents a cache for managing resources with a limit on the number of resources.
 */
export class Cache {
    constructor(resourceLimit) {
        this.resourceLimit = resourceLimit
        this.data = {}
    }
}